import React from 'react'
import WeDelivered from '../Components/About/WeDelivered';
import Breadcrumbs from '../Components/banner/New-banner';

import AboutUs from '../Components/About/About';
import AboutMeSection from '../Components/About/Aboutme';
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import Team from "../Components/Team/Team";
import Testimonial from "../Components/Testmonial/Testimonial";
import BuiltFarmers from '../Components/About/BuiltFarmers';
// import LogoCarousel from "../Components/LogoCarousel/LogoCarousel";
function Rabout() {
    return (
        <>

            <Combaintop />
            <Breadcrumbs />
            <BuiltFarmers />
            <AboutUs />
            <AboutMeSection />
            <WeDelivered />
            <Team />
            <Testimonial />
            {/* <LogoCarousel /> */}
            <Combainbottom />
        </>
    )

}

export default Rabout;
